export const SET_AUTH = "setUser"
export const SET_ERROR = "setError"
export const PURGE_AUTH = "logout"
